var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAidev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 42,
    viewBox: "0 0 36 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7998 30.3649V17.1999C33.7998 10.035 33.7998 6.45167 31.573 4.22678C29.3462 2.0019 25.7647 2 18.5999 2H16.6999C9.53504 2 5.95167 2 3.72678 4.22678C1.5019 6.45357 1.5 10.035 1.5 17.1999V35.2498",
    stroke: "#FF9515",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7998 30.4998H6.24997C4.9902 30.4998 3.78202 31.0002 2.89123 31.891C2.00044 32.7818 1.5 33.99 1.5 35.2497C1.5 36.5095 2.00044 37.7177 2.89123 38.6085C3.78202 39.4992 4.9902 39.9997 6.24997 39.9997H33.7998",
    stroke: "#FF9515",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7998 40.0001C32.54 40.0001 31.3318 39.4996 30.441 38.6088C29.5502 37.718 29.0498 36.5099 29.0498 35.2501C29.0498 33.9903 29.5502 32.7822 30.441 31.8914C31.3318 31.0006 32.54 30.5001 33.7998 30.5001M18.2351 21.0002L15.4592 12.4104C15.3631 12.1396 15.1842 11.906 14.9478 11.7427C14.7115 11.5793 14.4297 11.4945 14.1425 11.5003C13.8553 11.4945 13.5735 11.5793 13.3372 11.7427C13.1008 11.906 12.9219 12.1396 12.8258 12.4104L10.0499 21.0002M23.3498 11.5003V21.0002M11.0721 18.1502H17.211",
    stroke: "#FF9515",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAidev);
export default __webpack_public_path__ + "static/media/aidev.4b7b421b1781b75619e863c343ff905f.svg";
export { ForwardRef as ReactComponent };